import {
  type ModelInfo,
  PROVIDERS,
  type ProviderType,
} from '@/lib/ai-providers'
import { theme } from '@/lib/theme'

interface ProviderModelSelectorProps {
  availableProviders: ProviderType[]
  selectedProvider: ProviderType | null
  selectedModel: string | null
  availableModels: ModelInfo[]
  isLoadingModels: boolean
  modelError: string | null
  onProviderChange: (provider: ProviderType) => void
  onModelChange: (modelId: string) => void
}

export default function ProviderModelSelector({
  availableProviders,
  selectedProvider,
  selectedModel,
  availableModels,
  isLoadingModels,
  modelError,
  onProviderChange,
  onModelChange,
}: ProviderModelSelectorProps) {
  return (
    <>
      <span
        style={{
          color: theme.colors.secondaryText,
          fontSize: theme.fontSize.sm,
        }}
      >
        Provider:
      </span>
      <select
        value={selectedProvider || ''}
        onChange={(e) => onProviderChange(e.target.value as ProviderType)}
        disabled={isLoadingModels}
        style={{
          backgroundColor: theme.colors.primaryBg,
          color: theme.colors.primaryText,
          border: `1px solid ${theme.colors.primaryBorder}`,
          borderRadius: theme.borderRadius.sm,
          padding: theme.spacing.xs,
          fontSize: theme.fontSize.sm,
        }}
      >
        {availableProviders.map((provider) => (
          <option key={provider} value={provider}>
            {PROVIDERS[provider].name}
          </option>
        ))}
      </select>

      <span
        style={{
          color: theme.colors.secondaryText,
          fontSize: theme.fontSize.sm,
        }}
      >
        Model:
      </span>
      {isLoadingModels ? (
        <span
          style={{
            color: theme.colors.secondaryText,
            fontSize: theme.fontSize.sm,
          }}
        >
          Loading models...
        </span>
      ) : modelError ? (
        <span
          style={{
            color: theme.colors.secondaryText,
            background: theme.colors.errorBg,
            fontSize: theme.fontSize.xs,
          }}
        >
          Error loading models! Check your API key.
        </span>
      ) : (
        <select
          value={selectedModel || ''}
          onChange={(e) => onModelChange(e.target.value)}
          disabled={!selectedProvider || availableModels.length === 0}
          style={{
            backgroundColor: theme.colors.primaryBg,
            color: theme.colors.primaryText,
            border: `1px solid ${theme.colors.primaryBorder}`,
            borderRadius: theme.borderRadius.sm,
            padding: theme.spacing.xs,
            fontSize: theme.fontSize.sm,
            flex: 1,
            minWidth: '120px',
          }}
        >
          {availableModels.map((model) => (
            <option key={model.id} value={model.id} title={model.description}>
              {model.id}
            </option>
          ))}
        </select>
      )}
    </>
  )
}
